// extracted by mini-css-extract-plugin
export default {"customCol":"Steps_customCol__TQuOu","customRow":"Steps_customRow__0uAb-","steps__span":"Steps_steps__span__k6B9+","steps__p":"Steps_steps__p__zUEM6"};